import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Typography from '../Typography';
import DownArrowKeyboard from '../../icons/KeyboardDownArrow';

const Accordian = styled.div`
  background: #fff;
  padding: 14px 0px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.Neutral[200]};
  color: ${({ theme }) => theme.colors.TextAlpha};
  @media screen and (min-width: 768px) {
    color: ${({ theme }) => theme.colors.TextDelta};
    ${({ level }) =>
      level === 2 &&
      css`
        color: ${({ theme }) => theme.colors.TextAlpha};
        padding: 8px 0px;
      `} :
  }
  ${({ active, level }) =>
    (active || level === 2) &&
    css`
      border-bottom: none;
      padding: 12px 0px;
    `}
`;

const Content = styled.div`
  background: #fff;
  animation: heightIn 0.5s ease-out;
  p {
    padding: 10px 0;
    margin: 0;
  }
  ${({ active }) =>
    active &&
    css`
      border-bottom: 1px solid ${({ theme }) => theme.colors.Neutral[200]};
    `}
  ${({ level }) =>
    level === 2 &&
    css`
      border-bottom: none;
      @media screen and (min-width: 768px) {
        margin-left: 20px;
      }
    `}
`;

const Ul = styled.ul`
  ${({ level }) =>
    level === 2 &&
    css`
      background: ${({ theme }) => theme.colors.Neutral[500]};
    `}
`;

const ViewMore = styled.div`  
  padding: 10px 0 20px;
  color: ${({ theme }) => theme.colors.Primary};
`;

const List = styled.li`
  a {
    padding: 10px 15px;
    color: ${({ theme }) => theme.colors.TextAlpha};
    @media screen and (min-width: 768px) {
      ${({ level }) =>
      !level &&
      css`
        padding: 10px 0px;
      `}
    }
  }
  &:last-child {
    ${({ level }) =>
    level === 2 &&
    css`
      padding-bottom: 10px;
    `}
  }
  &:hover > a {
    color: ${({ theme }) => theme.colors.Primary};
  }
`;
const DownArrow = styled(DownArrowKeyboard)`
  right: 10px;
  transition: all 0.3s ease-in-out;
  ${({ active }) =>
    active &&
    css`
      transform: rotate(-180deg);
    `}
`;

const Typo = styled(Typography)`
  @media screen and (max-width: 768px) {
    padding-left: 15px; 
    padding-right: 30px;
  }
`;

const Plus = styled(Typo)`
  right: 5px;
  padding-right: 10px;
`;

const Collapse = ({ data = [], level, enableviewmore, isMobile }) => {
  const [activeTab, changeActiveTab] = useState(0);
  const [viewmore, setViewmore] = useState(false);
  return (
    <>
      {data.map(({ title, content, name }, index) => {
        const isActive = index == activeTab;
        let viewContent = content;
        if (enableviewmore && !viewmore) {
          viewContent = content.slice(0, 5);
        }
        const modifiers = ['bt1', 'bold'];
        if (isMobile) {
          if(level === 2){
            modifiers[1] = 'semibold';
          } else {
            modifiers[1] = 'medium';
          }
        }
        return (
          <div key={`collapse${index}`}>
            <Accordian
              className="w100 pR cP dFA"
              active={isActive}
              onClick={() => changeActiveTab(isActive ? -1 : index)}
              level={level}
            >
              {!isMobile && level == 2 && (
                <Plus tagName="span" modifiers={['h2', 'medium']}>
                  {isActive ? '-' : '+'}
                </Plus>
              )}
              <Typo tagName="span" className="Ell" modifiers={modifiers}>
                {title || name}
              </Typo>
              {!isMobile && level == 2 ? (
                <></>
              ) : isMobile && level == 2 ? (
                <Plus className="pA" tagName="span" modifiers={['h2', 'medium']}>
                  {isActive ? '-' : '+'}
                </Plus>
              ) : (
                <DownArrow className="pA" active={isActive} />
              )}
            </Accordian>
            {isActive && (
              <Content active={isActive} level={level} className={!isActive && 'closeCollapse'}>
                {viewContent[0].subtype ? (
                  <Collapse
                    key={`collap2${index}`}
                    data={viewContent}
                    level={2}
                    isMobile={isMobile}
                    enableviewmore={false}
                  />
                ) : (
                  <Ul level={level}>
                    {viewContent.map((info, i) => (
                      <List level={level} key={i} className="cP">
                        <Typo tagName="a" className="dB" modifiers={['bt1']} href={info.href}>
                          {info.name}
                        </Typo>
                      </List>
                    ))}
                  </Ul>
                )}
                {enableviewmore && content.length > 5 && (
                  <ViewMore level={level} className="cP" onClick={() => setViewmore(!viewmore)}>
                    <Typo tagName="span" modifiers={['bt1',`${isMobile ? 'semibold' : 'bold'}`]}>
                      {viewmore ? 'Less' : 'More'}
                    </Typo>
                  </ViewMore>
                )}
              </Content>
            )}
          </div>
        );
      })}
    </>
  );
};

Collapse.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.arrayOf(
        PropTypes.shape({
          href: PropTypes.string,
          name: PropTypes.string
        })
      )
    })
  ),
  level: PropTypes.number,
  enableviewmore: PropTypes.bool,
  isMobile: PropTypes.bool
};

Collapse.defaultProps = {
  enableviewmore: true
};

export default Collapse;
